import * as styles from '../../styles'

type OnPlanMessageProps = {
  planTitle?: string
}

export const OnPlanMessage: React.FC<OnPlanMessageProps> = ({ planTitle }) => (
  <div css={styles.messageContainer} className={styles.classes.messageClass}>
    {planTitle
      ? `This moment is already on the plan "${planTitle}". Remove it first to add it to a different one.`
      : 'This moment is already on a plan. Remove it first to add it to a different one.'}
  </div>
)
